// 定义全局方法
export default {
    // 示例1：格式化日期
    formatDate(time) {
        if (!time) return ''
        const d = new Date(time)
        return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`
    },
    // 示例2：滚动到顶部
    scrollToTop() {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    // 自定义你的业务方法...
    getRandomNum(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min
    },
    scrollIntoView(id) {
        const element = document.getElementById(id);
        console.log(element, 'element')
        // 元素在屏幕中间位置
        if (element) {
            window.scrollTo({
                top: element.offsetTop - 200,
                behavior: 'smooth' // 平滑滚动
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/globalMethods.js